export default {
  nav_home: 'Strona główna',
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Kategorie',
  nav_guides: 'Poradniki',
  nav_safety: 'Bezpieczeństwo',
  nav_faq: 'FAQ',
  nav_shopping_guide: 'Poradnik zakupowy',
  cta_spreadsheet: 'Kakobuy Spreadsheet',
  cta_buy_now: 'Buy It Now',
  cta_check_spreadsheet: 'Przeglądaj Kakobuy Spreadsheet',
  cta_read_guide: 'Zobacz przewodnik Kakobuy',
  trust_updated: 'Aktualizowane listy produktów',
  trust_guides: 'Poradniki dla Polski',
  trust_prices: 'Porównania cen',
  trust_safe: 'Bezpieczne zakupy',
  footer_copyright: '© 2026 Kakobuy Polska. Wszelkie prawa zastrzeżone.',
  footer_disclaimer: 'Nie jesteśmy oficjalnym partnerem Kakobuy.com. Strona ma charakter informacyjny.',
  breadcrumb_home: 'Strona główna',
  breadcrumb_blog: 'Blog',
  article_read_time: 'min czytania',
  article_author: 'Zespół Kakobuy Polska',
  scroll_top: 'Do góry',
  blog_section_title: 'Artykuły i Poradniki Kakobuy',
  blog_section_subtitle: 'Poznaj nasze szczegółowe przewodniki i porównania. Wszystko, co musisz wiedzieć o zakupach przez Kakobuy.',
  blog_read_more: 'Czytaj więcej',
  blog_updated: 'Zaktualizowano',
  article_cta_spreadsheet: 'Przejdź do Kakobuy Spreadsheet',
  article_cta_main: 'Odwiedź kaspreadsheet.com',
  article_related: 'Powiązane artykuły',
  article_toc: 'Spis treści',
};